/*
 * Cart set-overlap notice: "Keep both" hides the notice for this set + product pair for the
 * rest of the visit. Removing uses the theme's own cart-remove-button. Never edits the bag.
 */
(() => {
  if (customElements.get('set-overlap-notice')) return;
  const STORAGE_KEY = 'naturall-set-overlap-kept';

  function keptKeys() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  class SetOverlapNotice extends HTMLElement {
    connectedCallback() {
      if (keptKeys().includes(this.dataset.key)) {
        this.hide();
        return;
      }
      const keep = this.querySelector('[data-keep-both]');
      if (keep) keep.addEventListener('click', () => this.keepBoth());
    }

    keepBoth() {
      const keys = keptKeys();
      if (!keys.includes(this.dataset.key)) keys.push(this.dataset.key);
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(keys));
      } catch (e) {
        /* storage unavailable: still hide for now */
      }
      this.hide();
    }

    hide() {
      this.hidden = true;
      const wrapper = this.closest('.cart-set-overlap');
      if (wrapper && !wrapper.querySelector('set-overlap-notice:not([hidden])')) wrapper.hidden = true;
    }
  }

  customElements.define('set-overlap-notice', SetOverlapNotice);
})();
